module.exports = __webpack_public_path__ + "img/isologo.9e7a54a9.png";